import $ from 'jquery';
import {atelierVisit} from '../api/api';
import heightAnimate from '../../scripts/util/animate/heightAnimate';
import 'air-datepicker';

export default class Atelier {
	constructor(options) {
		const defaults = {
			el: '.js-content',
			dom: {
				page: '.js-atelier-page',
				form: '.js-popup-form',
				hide: '.js-hide',
				content: '.js-content-wrap',
				datepicker: '.js-datepicker',
				date: '.js-atelier-date',
				popup: '.js-popup',
				message: '.js-popup-atelier-message'
			},
			classes: {
				content: {
					state: {
						hidden: 'atelier__contents_state_hidden',
						show: 'atelier_state_show'
					}
				},
				status: {
					visible: 'popup_status_visible'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$page = $(this.options.dom.page);
	}

	getDom() {
		this.$popup = this.$page.find(this.options.dom.popup);
		this.$form = this.$page.find(this.options.dom.form);
		this.$hide = this.$el.find(this.options.dom.hide);
		this.$content = $(this.options.dom.content);
		this.$datepicker = $(this.options.dom.datepicker);
		this.$date = $(this.options.dom.date);
	}

	toggleMore = e => {
		const $target = $(e.target);
		const $wrap = $target.closest(this.options.el);
		const stateShow = this.options.classes.content.state.show;
		if ($wrap.hasClass(stateShow)) {
			heightAnimate(this.$content, 0.4);
		} else {
			heightAnimate(this.$content, 0.4, 'close');
		}
		$wrap.toggleClass(stateShow);
	}

	onDateSelect = formattedDate => {
		this.$date.val(formattedDate);
	}

	showStatus = message => {
		const $message = this.$popup.find(this.options.dom.message);
		this.$popup.addClass(this.options.classes.status.visible);
		$message.text(message);
	}

	onSubmit = e => {
		e.preventDefault();
		const $target = $(e.target);
		const $data = $target.serialize();
		atelierVisit($data).then(
			data => this.showStatus(data.message),
			data => this.showStatus(data.message)
		);
	}

	renderCalendar = () => {
		if (this.$datepicker.length) {
			this.$datepicker.datepicker({
				showOtherYears: false,
				selectOtherYears: false,
				onSelect: this.onDateSelect,
				minDate: new Date()
			});
		}
	}

	render() {
		if (this.$page.length) {
			this.getDom();
			this.renderCalendar();
			this.$hide.on('click', this.toggleMore);
			this.$form.on('submit', this.onSubmit);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/atelier/atelier.js
 **/